import queryString from 'query-string';

/**
 * TODO Low: Extend generic filter class?
 */
common.View.create('shop::website.modules.shopProducts.index.filters.Brands', {

    onDOMLoad()
    {
        this.initFilters();
    },

    getFilterSlug()
    {
        return this.element.data('filter-slug');
    },

    initFilters()
    {
        this.element

            // Listen for input change.
            .find('input')
                .change(() => this.onChange())
                .end();
    },

    onChange()
    {
        //
        let parentFilters = shop.website.modules.shopProducts.index.Filters.getInstance(this);

        parentFilters.onUserInput();
    },

    getFilterQuery()
    {
        // Get checked values.
        let checkedValues = [];

        for(let inputElement of this.element.find('input:checked'))
            checkedValues.push($(inputElement).val());

        // Abort due to none?
        if(checkedValues.length === 0)
            return null;

        // Sort
        checkedValues.sort();

        // Build query param.
        return {
            [this.element.data('filter-slug')]: checkedValues.join('|'),
        };
    },

    setByUrl()
    {
        // Get checked values from url.
        let query = queryString.parse(location.search);

        let checkedValues = (query[this.getFilterSlug()] || '').split('|').filter(Boolean);

        // Uncheck all inputs.
        let inputs = this.element.find('input')
                        .prop('checked', false)
                        .attr('checked', false);

        // Loop inputs.
        for(let inputElement of this.element.find('input'))
        {
            // Check due to has selected value?
            if(checkedValues.indexOf($(inputElement).val()) !== -1)
                $(inputElement)
                    .prop('checked', true)
                    .attr('checked', true);
        }
    },

    setByHtml(html)
    {
        // Get selected ids. User may have selected less / more inputs while loading the page.
        let selectedIds = this.element.find('input:checked')
            .map((i, inputElement) => $(inputElement).val());

        // Update HTML.
        this.element.replaceWith(html);

        // Check the selected ones again.
        for(let selectedId of selectedIds)
           this.element
                .find('input[value="' + selectedId + '"]')
                    .prop('checked', true)
                    .attr('checked', true);
    },

});
